import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormTextField from '../../../FormFields/FormTextField';
import FormTitle from '../../../FormFields/FormTitle';
import { REPORTS } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { validateEmail } from '../../../ValidateFunctions';

EMARDataForm.propTypes = {
  permissions: PropTypes.object,
};

export default function EMARDataForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [REPORTS.EMAR_DATA_SOURCE.id, REPORTS.EMAR_EMAIL.id];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          EMAR Data
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {REPORTS.EMAR_DATA_SOURCE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Data Source' }} />
              <FormTextField
                fieldName={REPORTS.EMAR_DATA_SOURCE.fieldName}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                fieldAttributes={{
                  isEditable: permissions[REPORTS.EMAR_DATA_SOURCE.id],
                }}
              />
            </Grid>
          )}
          {REPORTS.EMAR_EMAIL.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
              <FormTextField
                fieldName={REPORTS.EMAR_EMAIL.fieldName}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                fieldAttributes={{
                  isEditable: permissions[REPORTS.EMAR_EMAIL.id],
                  validation: {
                    pattern: { ...validateEmail },
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
